import List from 'list.js'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setRestaurantProgressFetched } from 'store/Dashboard/actions'
import { setRestaurantProgress } from 'store/Dashboard/actions'
import AxiosInstance from 'utils/AxiosInstance'

export function useRestaurantProgress() {
  const dispatch = useDispatch()

  const {
    restaurantProgressFetched,
    restaurantProgressData: {
      locations,
      tableList,
      locationFilter,
      locationFilterWord,
      locationRoleName,
      locationRoles,
    },
    skipLocations,
  } = useSelector((state) => state.dashboard)

  const locationsTable = useRef(null)

  let locationIds = []

  const fetchUserProgress = (role_id = null, role_name = '', reset = false) => {
    if (role_id) {
      dispatch(setRestaurantProgress({ selectedLocationsJobRole: role_id }))
    } else {
      dispatch(setRestaurantProgress({ selectedLocationsJobRole: 0 }))
    }

    if (role_name) {
      dispatch(setRestaurantProgress({ locationRoleName: role_name }))
    } else {
      dispatch(setRestaurantProgress({ locationRoleName: 'All' }))
    }

    dispatch(setRestaurantProgress({ locationFilterWord: '' }))
    if (!locationFilter) {
      dispatch(setRestaurantProgress({ locationFilter: '' }))
    }
    dispatch(setRestaurantProgress({ progressLoading: true }))

    let url = ''
    role_id !== null
      ? (url = `manager-reports?role_id=${role_id}&skip=${skipLocations}&from=dashboard`)
      : (url = `manager-reports?skip=${
          reset ? 0 : skipLocations
        }&locationSearch=${locationFilter}&from=dashboard`)

    console.log(url, 'leart53')

    AxiosInstance.get(url).then((res) => {
      if (!res.data) {
        dispatch(setRestaurantProgressFetched(true))
        dispatch(setRestaurantProgress({ progressLoading: false }))
        return
      }

      dispatch(setRestaurantProgress({ showLoadMore: res.showLoadMore }))

      let lastLocationId = 0
      let array = []
      for (let i = 0; i < res.data?.length; i++) {
        if (res.data[i].module === 'location') {
          if (i !== 0) {
            lastLocationId++
          }
          array[lastLocationId] = {
            locationData: res.data[i],
            users: [],
          }
          locationIds.push(res.data[i].module_id)
        } else {
          array[lastLocationId].users.push(res.data[i])
        }
      }

      locationIds = locationIds.join(',')
      dispatch(setRestaurantProgress({ progressLoading: false }))
      // if (!locationFilter) {
      console.log(role_id, role_name, skipLocations, reset, 'leart88')

      if (role_id && role_name) {
        dispatch(setRestaurantProgress({ locations: [] }))
        dispatch(setRestaurantProgress({ locations: array }))
      } else {
        if (role_name === 'All' && reset) {
          dispatch(setRestaurantProgress({ locations: [] }))
          dispatch(setRestaurantProgress({ locations: array }))
        } else {
          dispatch(
            setRestaurantProgress({ locations: [...locations, ...array] })
          )
        }
      }
      // } else {
      //   dispatch(setRestaurantProgress({ locations: array }))
      // }

      fetchRolesByLocations(locationIds)
      dispatch(setRestaurantProgressFetched(true))
    })
  }

  const fetchRolesByLocations = (locationIds) => {
    AxiosInstance.get(
      `/manager-reports/role-count?module_id=${locationIds}`
    ).then((data) => {
      dispatch(setRestaurantProgress({ locationRoles: data }))
    })
  }

  //reindexing table list
  useEffect(() => {
    if (locations && locations.length > 0) {
      if (!tableList) {
        dispatch(
          setRestaurantProgress({
            tableList: new List(locationsTable.current, {
              valueNames: ['status'],
              item: '<li><p class="status"></p></li>',
              // listClass: "list",
            }),
          })
        )
      } else {
        tableList.reIndex()
      }
    }
  }, [locations, locationFilter, locationFilterWord])

  //debouncing the Location search filter
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setRestaurantProgress({ locationFilterWord: locationFilter }))
    }, 500)

    return () => {
      clearTimeout(timer)
    }
  }, [locationFilter])

  useEffect(() => {
    if (restaurantProgressFetched) return
    fetchUserProgress(
      locationRoles?.find((lr) => lr?.name === locationRoleName),
      locationRoleName
    )
  }, [restaurantProgressFetched, skipLocations, locationFilter])

  return {
    fetchUserProgress,
    locationsTable,
  }
}
